import OrderSettingCom from "../../components/OrderSetting";
const OrderSetting = () => {
  return (
    <>
      <OrderSettingCom />
    </>
  );
};

export default OrderSetting;
